import React, { useContext } from "react";
import Swal from "sweetalert2";
import MyContext from "../MyContext";



const PrintModal = ({
  heading,
  subHeading,
  isOpen,
  onClose,
  Reload,
  PrintBill,
  showFormat1 = true,
  showFormat2 = true,
  showSendMsg = true,
  showEmail = true,
  showBarcode = true,
  billSeriesWiseTemplateSetting,
  backToReportBtn,
  hideBackToReportBtn
}) => {

  const { UserDetails } = useContext(MyContext);

  if (!isOpen) return null;

  console.log({ billSeriesWiseTemplateSetting })
  console.log(billSeriesWiseTemplateSetting.printWindowBtnSetting)



  return (
    <div className="BillBar-modal" style={{zIndex:10}}>
      <div className="BillBar-modal-content relative">
        <div className="BillBar-modal-header">
          <h2>{heading}</h2>
          {/* <button style={{position:"absolute", top}}>Back to Report</button> */}

          <div className="BillBar-modal-relative-buttons">

            <button onClick={onClose} className="BillBar-modal-close">
              ✖
            </button>

          </div>

        </div>
        <p className="mt-2">{subHeading}</p>
        <div className="BillBar-modal-buttons">

          {billSeriesWiseTemplateSetting.printWindowBtnSetting &&
            billSeriesWiseTemplateSetting.printWindowBtnSetting.filter((data, index) => data.hideShow).map((data, index) => {

              if (Number(data.btnType) <= 5) {

                return (
                  <button key={index} onClick={() => PrintBill(data.templateName, data.btnType)} className="BillBar-modal-button BillBar-modal-format1">
                    {data.btnNameByUser}
                  </button>
                );

              } else {

                if (data.btnType == 6) {

                  return (
                    <button key={index} onClick={() => {

                      if (UserDetails && UserDetails.canSms) {
                        PrintBill(data.templateName, data.btnType);
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "You have not permission to send sms!",
                          text: "",
                          timer: 2000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          width: "250px",
                          customClass: {
                            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                          },
                        });
                      }
                    }}
                      style={{ backgroundColor: "#ff6500" }} className="BillBar-modal-button">
                      {data.btnNameByUser}
                    </button>
                  );

                } else if (data.btnType == 7) {

                  return (
                    <button key={index} onClick={() => {

                      if (UserDetails && UserDetails.canEmail) {
                        PrintBill(data.templateName, data.btnType);
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "You have not permission to send email!",
                          text: "",
                          timer: 2000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          width: "250px",
                          customClass: {
                            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                          },
                        });
                      }
                    }}
                      style={{ backgroundColor: "#076107" }} className="BillBar-modal-button">
                      {data.btnNameByUser}
                    </button>
                  );

                } else if (data.btnType == 8) {

                  return (
                    <button key={index} onClick={() => PrintBill(data.templateName, data.btnType)} style={{ backgroundColor: "#076107" }} className="BillBar-modal-button">
                      {data.btnNameByUser} <i style={{ position: "relative", top: "2px", left: "5px" }} class="fa-solid fa-share"></i>
                    </button>
                  );

                } else if (data.btnType == 9) {


                  return (
                    <button key={index} onClick={() => PrintBill(data.templateName, data.btnType)} style={{ backgroundColor: "#ff6500" }} className="BillBar-modal-button">
                      {data.btnNameByUser}
                    </button>
                  );


                } else if (data.btnType == 10) {

                  return (
                    <button key={index} onClick={() => PrintBill(data.templateName, data.btnType)} style={{ backgroundColor: "#076107" }} className="BillBar-modal-button">
                      {data.btnNameByUser} <i style={{ position: "relative", top: "2px", left: "5px" }} class="fa-brands fa-whatsapp"></i>
                    </button>
                  );

                }

                return (
                  <button key={index} onClick={() => PrintBill(data.templateName, data.btnType)} className="BillBar-modal-button BillBar-modal-sendmsg">
                    {data.btnNameByUser}
                  </button>
                );

              }
            })}


        </div>
        <div className="mt-4" style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
          <button onClick={Reload} style={{ backgroundColor: "red" }} className="BillBar-modal-close-btn">
            Reload
          </button>
          {hideBackToReportBtn === false && (
            <button onClick={backToReportBtn} style={{ backgroundColor: "gray" }} className="BillBar-modal-close-btn">
              Back To Report
            </button>
          )}

        </div>
      </div>
    </div>
  );
};

export default PrintModal;
